module.exports = {"id":"dp2_5l3q5","text":"Digital Behaviour","instructions":"Automated moderation systems can influence what behaviour is visible online.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.5","questionType":"PickOne","random":false,"options":[{"id":"dp2_5l3q5-a1","text":"True","score":3.7},{"id":"dp2_5l3q5-a2","text":"Not sure","score":1.3},{"id":"dp2_5l3q5-a3","text":"False","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.5/l3q5.json
// module id = 1076
// module chunks = 41